/**
 * 공통 Analytics Tracking Hooks
 *
 * 반복되는 트래킹 패턴을 재사용 가능한 훅으로 제공합니다.
 *
 * @note 전역 트래킹(Scroll, Time Spent)은 GlobalAnalyticsTracker에서 처리합니다.
 *
 * @example
 * ```tsx
 * import {
 *   usePageViewTracking,
 *   useModalTracking,
 * } from '@/features/common/analytics';
 * ```
 */

// 모달 상태 트래킹 (열림/닫힘/확인/취소)
export { useModalTracking } from './useModalTracking';

// 페이지 뷰 트래킹 (마운트 시 1회)
export { usePageViewTracking } from './usePageViewTracking';

// 섹션 뷰포트 진입 트래킹 (Intersection Observer)
export { useSectionViewTracking } from './useSectionViewTracking';

// 탭 전환 트래킹
export { useTabTracking } from './useTabTracking';
